import { ref } from 'vue';

export default function useResizeObserver() {
  const observer = ref(null);

  const observeElements = (elements, callback) => {
    if (!observer.value) {
      observer.value = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          callback(entry);
        });
      });
    }

    elements.forEach((element) => {
      if (element) {
        observer.value.observe(element);
      }
    });
  };

  const unobserveElements = (elements) => {
    if (observer.value) {
      elements.forEach((element) => {
        if (element) {
          observer.value.unobserve(element);
        }
      });
    }
  };

  const disconnectObserver = () => {
    if (observer.value) {
      observer.value.disconnect();
      observer.value = null;
    }
  };

  return {
    observeElements,
    unobserveElements,
    disconnectObserver
  };
}
